import { pointsToEN } from '../ol-utils';
import { FeatureMouseInteraction } from '../interaction/FeatureMouseInteraction';
import Feature, { FeatureLike } from 'ol/Feature';
import { LineString } from 'ol/geom';
import * as olStyle from 'ol/style';
import { PipeFeatureFactory } from '@openlayers/pipes/PipeFeatureFactory';
import { ColorService } from '@shared/codelist/color-service';
import { RGBAColor, StringLineStyle } from '@shared/codelist/types';

const FEATURE_TYPE = 'stringline';

const sharedStyles = {
    hitArea: new olStyle.Style({
        stroke: new olStyle.Stroke({
            color: [0, 0, 0, 0.005],
            width: 10,
        }),
    }),
};

function styleFunction(feature: FeatureLike, resolution) {
    return PipeFeatureFactory.styleFunction(feature);
}

function makeFeature(stringline: IOutlinePolyline, mouseInteraction?: FeatureMouseInteraction): Feature {
    stringline = JSON.parse(JSON.stringify(stringline)); // later, some code somewhere modifies points array, make a copy to make sure its original one in get('data')
    if (!stringline || !stringline.hasOwnProperty('points')) {
        console.warn('Skipping bad stringline: ', stringline);
        return null;
    }

    const coords: Coordinate[] = pointsToEN(stringline.points);
    if (!coords) {
        console.warn('Skipping bad stringline, cant convert point coordinates: ', stringline);
        return null;
    }

    const lineFeature = new Feature({
        geometry: new LineString(coords),
    });
    const source: FeatureSource = {
        modelId: stringline.modelId,
    };

    const hasAnyPipeProperty = Object.entries(stringline.props || {}).some(([key, val]) => {
        return String(val).toLowerCase().includes('ifcflow') || String(key).toLowerCase().includes('pipe');
    });

    // already has linetype defined, do nothing
    if (!stringline.props.linetype) {
        const stringLineStyle: StringLineStyle = ColorService.getLineStyleFromStringLine(stringline);
        stringline.props.linetype = stringLineStyle;
    }

    const stringLineColor: RGBAColor = ColorService.getLineColorFromStringLine(stringline);
    const rgb = [stringLineColor.r, stringLineColor.g, stringLineColor.b];
    const rgbColorStr = rgb.join(',');

    // Set color if not set or is black. Shapefiles have colors
    // added in parsing phase so we dont want to override those.
    if (!stringline.color || stringline.color === '0,0,0') {
        stringline.color = rgbColorStr;
    }

    lineFeature.set('source', source);
    lineFeature.set('data', stringline);
    lineFeature.set('type', FEATURE_TYPE);
    lineFeature.set('showElevationArrow', hasAnyPipeProperty || stringline.filename?.toLowerCase().includes('!arrow') /* norway has lots of files without properties */);
    lineFeature.set('mouseInteraction', mouseInteraction);
    lineFeature.set('zStart', stringline.points[0].elevation);
    lineFeature.set('zEnd', stringline.points[stringline.points.length - 1].elevation);
    return lineFeature;
}

export const StringlineFeatureFactory = {
    makeFeature,
    styleFunction,
    sharedStyles,
    FEATURE_TYPE,
};
